var React = require('react');

function SCheckmarkBlue12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_102730","data-name":"Path 102730","d":"M4.5,10a1.022,1.022,0,0,1-.8-.384l-2.488-3A1,1,0,1,1,2.789,5.383L4.5,7.376,9.212,1.385a1,1,0,1,1,1.576,1.23l-5.511,7A.978.978,0,0,1,4.5,10Z","fill":"var(--iconBlue, #1473e6)"}));
}

SCheckmarkBlue12.defaultProps = {"id":"s_checkmark_blue_12","width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = SCheckmarkBlue12;

SCheckmarkBlue12.default = SCheckmarkBlue12;
